import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { WorkspaceState } from '../../../_shared/state/workspace.state';
import { PropertyState } from '../../state/property.state';

@Injectable({
  providedIn: 'root',
})
export class LocalTrendsFacade {
  constructor(private workspaceState: WorkspaceState, private propertyState: PropertyState) {}

  getOpenLocalTrendsStatus(): Observable<any> {
    return this.workspaceState.openLocalTrendsSheet$;
  }

  closeLocalTrendsSheet(status) {
    this.workspaceState.openLocalTrendsSheetValue = status;
  }

  getZipCodeList(): Observable<any> {
    return this.propertyState.zipCodeList$;
  }
}
